import React from "react";
import { Button } from "@/components/ds";
import { useNavigate } from "react-router-dom";
import useIsMobile from "@/hooks/useIsMobile";

export default function Header({ onTalk }) {
  const nav = useNavigate();
  const isMobile = useIsMobile();
  return (
    <header
      data-testid="site-header"
      style={{
        position: "sticky", top: 0, zIndex: 40, display: "flex", alignItems: "center",
        justifyContent: "space-between", gap: 12, flexWrap: "wrap", padding: isMobile ? "11px 16px" : "14px 32px",
        background: "var(--surface-card)", borderBottom: "1px solid var(--border-default)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 10 : 14 }}>
        <img src="/locofast-logo.png" alt="Locofast" style={{ height: isMobile ? 26 : 30, width: "auto", display: "block" }} />
        <span style={{ width: 1, height: 20, background: "var(--border-default)" }} />
        <span style={{ font: `var(--fw-medium) ${isMobile ? 13 : 14}px/1.2 var(--font-sans)`, color: "var(--text-secondary)" }}>Denim Garment Catalogue</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <Button data-testid="talk-to-us-btn" variant="accent" size="sm" onClick={onTalk}>Talk to us</Button>
      </div>
    </header>
  );
}
